import 'react-app-polyfill/stable';
import 'globalthis/auto';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.less';
import App from './App';

if (process.env.REACT_APP_SENTRY_ENABLE === 'true') {
  import('@sentry/react').then((sentry) => {
    sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new sentry.BrowserTracing()],
      release: process.env.REACT_APP_SENTRY_RELEASE_VERSION,
      tracesSampleRate: 1.0,
    });
  });
}

if (process.env.REACT_APP_ERUDA_ENABLE === 'true') {
  import('eruda').then((eruda) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    eruda.default.init();
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLDivElement);
root.render(<App />);
